/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:08
 *
 */

import {
  Component,
  computed,
  effect,
  ElementRef,
  EventEmitter,
  input,
  Output,
  signal,
  SimpleChange,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ActionEvent,
  CommonUtils,
  StandardAction,
} from '@infodata-group/inf-commons';

const VALUE_CHANGE_ACTION = new StandardAction('valueChange', '');

@Component({
  selector: 'infl-cart-input-number',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cart-input-number.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cart-input-number.component.scss',
})
export class CartInputNumberComponent {
  public defaultValue = input<number>();
  public max = input<number>();
  public error = input<string>();
  public borderColor = input<string>();

  public currentValue = signal<number>(null);

  private previousEmittedValue: number;
  private isFirstChange = true;

  protected currentBorderColor = computed(() => {
    if (this.error()) {
      return CommonUtils.color('red');
    }
    if (this.borderColor()) {
      return this.borderColor();
    }
    return CommonUtils.color('black');
  });

  @ViewChild('inputElement') input: ElementRef<HTMLInputElement>;
  @Output() actionClick = new EventEmitter<ActionEvent>();

  constructor() {
    effect(() => {
      this.currentValue.set(this.defaultValue());
      this.emitValueChangeAction(this.defaultValue());
    });
  }

  protected onBlur() {
    const value = this.getCurrentValueFromInput();
    this.input.nativeElement.value = `${value}`;
    this.currentValue.set(value);
    this.emitValueChangeAction(value);
  }

  protected onChange() {
    const value = this.getCurrentValueFromInput();
    this.input.nativeElement.value = `${value}`;
    this.currentValue.set(value);
    this.emitValueChangeAction(value);
  }

  private getCurrentValueFromInput(): number {
    let value = parseInt(this.input.nativeElement.value);
    if (value > this.max()) {
      value = this.max();
    }
    return value;
  }

  private emitValueChangeAction(value: number) {
    if (this.previousEmittedValue !== value) {
      this.actionClick.emit(
        new ActionEvent(
          'click',
          VALUE_CHANGE_ACTION,
          new SimpleChange(
            this.previousEmittedValue,
            value,
            this.isFirstChange,
          ),
        ),
      );
      this.previousEmittedValue = value;
      this.isFirstChange = false;
    }
  }

  protected onClickDelete(): void {
    this.actionClick.emit(
      new ActionEvent('click', new StandardAction('delete', '')),
    );
  }
}
